import blogSeed from "@/data/blog.generated.json";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { API } from "@/lib/faro";
import { useMediaQuery } from "@/lib/useMediaQuery";

export default function BlogPreview() {
  const [posts, setPosts] = useState(Array.isArray(blogSeed.posts) ? blogSeed.posts : []);
  const isMobile = useMediaQuery("(max-width: 639px)");
  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <section id="blog" className="section-pad bg-white" data-testid="blog-preview">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-end justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <span className="eyebrow">Blog & Noticias</span>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl mt-3 leading-tight">
              Aprende seguridad vial con los profes de Faro.
            </h2>
          </div>
          {!isMobile && (
            <Link to="/blog" data-testid="blog-see-all" className="inline-flex items-center gap-1 text-sm font-bold text-[var(--faro-blue)] shrink-0">
              Ver todos <ArrowUpRight size={16} />
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((p) => (
            <Link
              key={p.id}
              to={`/blog/${p.slug || p.id}`}
              data-testid={`blog-card-${p.id}`}
              className="group rounded-2xl overflow-hidden border border-[rgba(30,42,143,0.12)] bg-white hover:-translate-y-1 hover:shadow-xl hover:shadow-[rgba(30,42,143,0.15)] transition-all"
            >
              <div className={p.image?.startsWith("/assets/blog/") ? "aspect-[1200/630] overflow-hidden bg-[var(--faro-blue-deep)]" : "aspect-[4/3] overflow-hidden"}>
                <img src={p.image} alt={p.title} width="1200" height="630" loading="lazy" className={`w-full h-full ${p.image?.startsWith("/assets/blog/") ? "object-contain" : "object-cover"} group-hover:scale-105 transition-transform duration-500`} />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between text-xs">
                  <span className="uppercase tracking-[0.18em] font-bold text-[var(--faro-red)]">{p.category}</span>
                  <span className="inline-flex items-center gap-1 text-[var(--faro-text-soft)]">
                    <Clock size={12} /> {p.read_minutes} min
                  </span>
                </div>
                <h3 className="mt-3 font-display font-bold text-lg leading-snug text-[var(--faro-text)] group-hover:text-[var(--faro-blue)] transition-colors">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-[var(--faro-text-soft)]">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
        {isMobile && (
          <div className="mt-6 flex justify-center">
            <Link to="/blog" data-testid="blog-see-all-mobile" className="btn-pill btn-ghost text-sm">
              Ver todos los artículos <ArrowUpRight size={16} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
